import * as React from 'react';
import { Box, Card} from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { useAppSelector } from '../../hooks'
import MapaClubes from './components/map/MapMain';
import GestionarUsuarios from './components/users/UsersMain'
import Metricas from './components/metrics/MetricsMain'
import { black } from '../../getLPTheme';
import ProfileEdit from '../user-view/components/profile/profileContainer'
import NotificationsContainer from '../user-view/components/notifications/notificationContainer'; 

// import { Status, Wrapper } from '@googlemaps/react-wrapper';

const theme = createTheme({
  palette: {
    primary: {
      main: '#7c7c7c',
      light: '#969696',
      dark: '#565656',
      contrastText: '#242105',
    },
    secondary: {
      main: '#bababa',
      light: '#bababa',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#bababa',
    },
  },
});


function MenuSelected() {
  
  let navigatorSelect = useAppSelector(state => state.navigator.value)

  if(navigatorSelect == 'Notificaciones'){
    return <NotificationsContainer/>;
  }
  
  if(navigatorSelect == 'Métricas Generales'){
    return <Metricas/>;
  }
  else if (navigatorSelect == 'Agregar Nuevo Punto') {
    // const render = (status: Status) => (<h1>{status}</h1>)
    // return <Wrapper apiKey={"AIzaSyA5ICennvJ9QdFWlbL0p_S8bA25P-mBBMo"} render={render}><MapaClubes/></Wrapper>
    return <MapaClubes/>
  }
  else if (navigatorSelect == 'Gestionar Usuarios') {
    return <GestionarUsuarios/>;
  }
  else if (navigatorSelect == 'Editar Perfil') {
    return <ProfileEdit/>;
  }
  else  {
    return <Metricas/>
  }       
}

export default function ContentAdmin() {
  return (
    <ThemeProvider theme={theme}>
      <Card sx={{ width: '100%'}}>
        <Box sx={{backgroundColor: black[1000], position: 'relative', paddingBottom: 1}}>
          <MenuSelected/>
        </Box>
      </Card>
    </ThemeProvider>
  );
}
